<ng-content> </ng-content>
<div id="scrolling-indicator" [style.width.%]="indicatorWidth()"></div>
